<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="24" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="工单号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.jobNo" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.jobNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单名称" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.title" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.title || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderName" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.senderName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方身份">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.rolesCode" placeholder="请选择发单方身份" style="width: 100%;" @change="GetCouponsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in roleOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.rolesName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="接单方" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.recriverName" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.recriverName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务来源" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.orderSource" placeholder="请选择服务来源" style="width: 100%;" @change="GetCouponsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in orderSourceOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.orderSourceStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="完成时间" >
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                            @change="GetCouponsList()"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.realIncomeBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.realIncomeEnd" style="width: 45%;" placeholder="搜索" @blur="GetCouponsList()" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.realIncome}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="接单方金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.estimateRevenueBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.estimateRevenueEnd" style="width: 45%;" placeholder="搜索" @blur="GetCouponsList()" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.estimateRevenue}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import { 
  getStorageToken,
} from '@/utils/store'
import {
    ordSouSerProfitList,roleOption,orderSourceOption,
} from "@/service/payApi";
  export default {
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                Name: '',               //名称
                EffectivityTime: [],    //时间
                estimateRevenueBegin:'',
                estimateRevenueEnd:'',
                jobNo:'',
                orderSource:'',
                realIncomeBegin:'',
                realIncomeEnd:'',
                recriverName:'',
                rolesCode:'',
                senderName:'',
                title:'',
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            roleOptionArr:[],
            orderSourceOptionArr:[],
        }
    },
    activated(){
        this.handleSearch()
        this.getRoleOption()
        this.getOrderSourceOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        
    },
    computed: {
    },
    mounted() {
    },
    methods: {
            getOrderSourceOption(){
                orderSourceOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.orderSourceOptionArr = r.Data
                })
            },
            getRoleOption(){
                var data = {rolesType :2};
                roleOption(data).then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.roleOptionArr = r.Data
                })
            },
            downloadFile() {
            const _this = this
            var data = {
            }
            
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }
            if(this.form.estimateRevenueBegin) data.estimateRevenueBegin = this.form.estimateRevenueBegin
            if(this.form.estimateRevenueEnd) data.estimateRevenueEnd = this.form.estimateRevenueEnd
            if(this.form.jobNo) data.jobNo = this.form.jobNo
            if(this.form.orderSource) data.orderSource = this.form.orderSource
            if(this.form.realIncomeBegin) data.realIncomeBegin = this.form.realIncomeBegin
            if(this.form.realIncomeEnd) data.realIncomeEnd = this.form.realIncomeEnd
            if(this.form.recriverName) data.recriverName = this.form.recriverName
            if(this.form.rolesCode) data.rolesCode = this.form.rolesCode
            if(this.form.senderName) data.senderName = this.form.senderName
            if(this.form.title) data.title = this.form.title

            let url =
            process.env.NODE_ENV == "development" ?
            "/api2" :
            process.env.VUE_APP_API2;

            window.open(
            url + "/gz/admin/download/ordSouSerProfit/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
            Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
            })
            ).join("&");
        },
        cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
        }
        return newArray;
      },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.GetCouponsList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        // TODO：修改接口名 form参数 table展示数据 -> 发单方身份、服务来源select
        async GetCouponsList(){
            const _this = this;
            this.listLoading = true
            // !data.Name && delete data.Name
            var data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,   
                rational:true,
            }
            data.Token = getStorageToken();
            data.platform = 'zyd'
            
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }
            if(this.form.estimateRevenueBegin) data.estimateRevenueBegin = this.form.estimateRevenueBegin
            if(this.form.estimateRevenueEnd) data.estimateRevenueEnd = this.form.estimateRevenueEnd
            if(this.form.jobNo) data.jobNo = this.form.jobNo
            if(this.form.orderSource) data.orderSource = this.form.orderSource
            if(this.form.realIncomeBegin) data.realIncomeBegin = this.form.realIncomeBegin
            if(this.form.realIncomeEnd) data.realIncomeEnd = this.form.realIncomeEnd
            if(this.form.recriverName) data.recriverName = this.form.recriverName
            if(this.form.rolesCode) data.rolesCode = this.form.rolesCode
            if(this.form.senderName) data.senderName = this.form.senderName
            if(this.form.title) data.title = this.form.title
            
            let res = await ordSouSerProfitList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>